import React from 'react';
import { Star, Quote } from 'lucide-react';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Michael Johnson",
      country: "Estados Unidos",
      rating: 5,
      text: "Excelente servicio! Me recogieron en el aeropuerto de Punta Cana con el vehículo listo. El proceso por WhatsApp fue super rápido y el equipo siempre respondió mis preguntas. Altamente recomendado para turistas.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop"
    },
    {
      name: "Sophie Martin",
      country: "Francia",
      rating: 5,
      text: "La mejor experiencia de alquiler de autos que he tenido. El Mercedes que alquilé estaba impecable y el servicio al cliente fue excepcional. Me ayudaron en español e inglés. Perfecto para recorrer la isla!",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop"
    },
    {
      name: "Carlos & Maria Rodriguez",
      country: "España",
      rating: 5,
      text: "Reservamos una Honda CR-V para nuestras vacaciones familiares. Todo fue muy fácil desde España, nos atendieron por WhatsApp y nos entregaron el vehículo en nuestro hotel. Muy profesionales!",
      image: "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=150&h=150&fit=crop"
    },
    {
      name: "John & Emily Williams",
      country: "Canadá",
      rating: 5,
      text: "Perfect service for tourists! We rented a Tahoe for our family trip and it was spotless. The 24/7 support gave us peace of mind. They delivered the car to our Airbnb in Santo Domingo. Highly recommended!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop"
    },
    {
      name: "Ana Paula Silva",
      country: "Brasil",
      rating: 5,
      text: "Serviço incrível! Aluguei um SUV para explorar Punta Cana e Samaná. A equipe foi muito atenciosa e o processo foi super rápido pelo WhatsApp. O carro estava perfeito e limpo. Recomendo 100%!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop"
    },
    {
      name: "Thomas Schmidt",
      country: "Alemania",
      rating: 5,
      text: "Excellent rental experience in Dominican Republic. Very professional service, new vehicles, and great communication. They made everything easy for us as tourists. Will definitely use them again!",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop"
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-700/20 border border-yellow-600/30 px-4 py-2 mb-6">
            <span className="text-yellow-600 text-sm font-medium">TESTIMONIOS</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Lo Que Dicen Nuestros Clientes
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            Miles de turistas han confiado en nosotros para su experiencia en República Dominicana
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-zinc-900 border border-white/10 p-8 hover:border-yellow-600/50 transition-all duration-300 group"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote className="w-10 h-10 text-yellow-600/30 group-hover:text-yellow-600 transition-colors duration-300" />
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-600 text-yellow-600" />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-white/80 leading-relaxed mb-6 italic">
                "{testimonial.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-6 border-t border-white/10">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover border-2 border-yellow-600/30"
                />
                <div>
                  <div className="text-white font-semibold">
                    {testimonial.name}
                  </div>
                  <div className="text-white/60 text-sm">
                    {testimonial.country}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Text */}
        <div className="text-center mt-16">
          <p className="text-white/70 text-lg">
            Únete a los cientos de turistas satisfechos que exploraron República Dominicana con nosotros
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
